import ProximaOTF from '../assets/fonts/Proxima_Nova_Medium.otf';
import ProximaLightOTF from '../assets/fonts/Proxima_Nova_Medium.otf';
import ProximaBoldOTF from '../assets/fonts/Proxima_Nova_Medium.otf';
import AvenirRomanOTF from '../assets/fonts/AvenirLTStd-Roman.otf';
import AvenirBookOTF from '../assets/fonts/AvenirLTStd-Book.otf';
import AvenirBlackOTF from '../assets/fonts/AvenirLTStd-Black.otf';

export const AvenirRomanFont = {
  fontFamily: 'Avenir',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Avenir'),
    url(${AvenirRomanOTF}) format('otf')
  `
};
export const AvenirBookFont = {
  fontFamily: 'Avenir',
  fontStyle: 'lighter',
  fontDisplay: 'swap',
  fontWeight: 300,
  src: `
    local('Avenir'),
    url(${AvenirBookOTF}) format('otf')
  `
};
export const AvenirBlackFont = {
  fontFamily: 'Avenir',
  fontStyle: 'bold',
  fontDisplay: 'swap',
  fontWeight: 900,
  src: `
    local('Avenir'),
    url(${AvenirBlackOTF}) format('otf')
  `
};

export const ProximaFont = {
  fontFamily: 'Proxima Nova',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Proxima Nova'),
    url(${ProximaOTF}) format('otf')
  `
};
export const ProximaLightFont = {
  fontFamily: 'Proxima Nova',
  fontStyle: 'lighter',
  fontDisplay: 'swap',
  fontWeight: 300,
  src: `
    local('Proxima Nova'),
    url(${ProximaLightOTF}) format('otf')
  `
};
export const ProximaBoldFont = {
  fontFamily: 'Proxima Nova',
  fontStyle: 'bold',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `
    local('Proxima Nova'),
    url(${ProximaBoldOTF}) format('otf')
  `
};
